module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("ixNGA"))).then(() => parcelRequire('cnB5G'));